export default __webpack_public_path__ + "static/media/wallet.c8f46565.png";